module.exports = __webpack_public_path__ + "img/pic_noOrders.1768119790257.png";